import type { ComponentProps } from 'react'

import { cn } from '@/util/cn'

function Cell({ children, className, ...props }: ComponentProps<'div'>) {
  return (
    <div
      className={cn('flex items-center justify-center bg-rsf-white rounded-lg', className)}
      {...props}
    >
      {children}
    </div>
  )
}

export default Cell
